<h2 class="text-center h3-tipografia-govco mb-0">
  {{"supersociedades-insolvencia.entrada" | translate}}
</h2>
<ol class="list-group list-group-numbered">
  <li class="list-group-item d-flex justify-content-between align-items-start"
      *ngFor="let documento of documentos">
    <div class="ms-2 me-auto">
      <div class="fw-bold">{{documento.nombre}}</div>
      Pendiente descripción...
    </div>
    <button
      id="descargarEntrada"
      class="btn-govco fill-btn-govco hvr-shrink ms-2"
      (click)="descargar(documento.id)"
      aria-label="Descargar documento">
      <span class="govco-svg govco-download me-2"></span>
      {{"descargar" | translate}}
    </button>
  </li>
</ol>
<!--<h2 class="text-center h3-tipografia-govco mb-0">-->
<!--  {{"supersociedades-insolvencia.salida" | translate}}-->
<!--</h2>-->
<!--<ol class="list-group list-group-numbered">-->
<!--  <li class="list-group-item d-flex justify-content-between align-items-start">-->
<!--    <div class="ms-2 me-auto">-->
<!--      <div class="fw-bold">borrador.pdf</div>-->
<!--      Borrador de...-->
<!--    </div>-->
<!--    <button-->
<!--      id="descargarSalida"-->
<!--      class="btn-govco fill-btn-govco hvr-shrink ms-2">-->
<!--      <span class="govco-svg govco-download me-2"></span>-->
<!--      {{"descargar" | translate}}-->
<!--    </button>-->
<!--  </li>-->
<!--</ol>-->
